import request from '../utils/request'

export default {
  async list (data) {
    const ret = await request('/v1/deviceMap/list', data,'POST')
    return ret
  },
  async save (data) { 
    const ret = await request('/v1/deviceMap/save', data,'POST')
    return ret
  },
  async delete (data) { 
    const ret = await request('/v1/deviceMap/delete', data,'POST')
    return ret
  },
  async beaconLists (data) {
    const ret = await request('/v1/deviceMap/beaconLists', data,'POST')
    return ret
  },
  async track (data) {
    const ret = await request('/v1/deviceMap/track', data,'POST')
    return ret
  }
}
